module.exports = __webpack_public_path__ + "img/withdrawalBlack.c6a0fbff.png";